<template>
    <div class="cart-list-container" :style="isMobile?mobileStyle:{}">
        <a-spin tip="加载中..." :spinning="isLoading">
            <div :class="{'list-loading':isLoading}">
                <div style="padding: 20px" v-if="cartList.length === 0 && !isLoading">
                    <a-empty description="暂无数据..." />
                </div>
                <template v-if="!isMobile">
                    <div class="cart-list clear-float" v-for="item in cartList" :key="item.shoppingCartId">
                        <ul class="cart-table">
                            <li>
                                <a-checkbox :checked="getSelected(item.shoppingCartId)"
                                            @change="onSelected($event,item)" />
                                <img :src=item.course.coverFileUrl alt="">
                            </li>
                            <li>
                                {{item.course.courseTitle}}
                            </li>
                            <li>
                                <div v-if="item.course.isDiscount == 0">
                                    ￥{{item.course.coursePrice}}
                                </div>
                                <div v-else>
                                    <span style="color:#999;text-decoration: line-through;">￥{{item.course.coursePrice}}</span>
                                    <span>￥{{item.course.discountPrice}}</span>
                                </div>
                            </li>

                            <li>
                                <div v-if="item.course.isDiscount == 0">
                                    <a-tag color="#108ee9" style="margin:0">原价</a-tag>
                                </div>
                                <div v-else>
                                    <a-tag color="#f50" style="margin:0">{{item.course.discountDesc}}</a-tag>
                                </div>
                            </li>

                            <li>
                                <a-icon class="delete" type="delete"
                                        @click="removeCart(item.shoppingCartId,item.course.courseTitle)" />
                            </li>
                        </ul>
                    </div>
                </template>
                <template v-else>
                    <div class="mobile-cart-list clear-float" v-for="item in cartList" :key="item.shoppingCartId">
                        <div class="course-cover">
                            <a-checkbox :checked="getSelected(item.shoppingCartId)" @change="onSelected($event,item)" />
                            <img :src=item.course.coverFileUrl alt="">
                        </div>
                        <ul class="mobile-course-desc">
                            <li>
                                {{item.course.courseTitle}}
                                <a-icon class="delete" type="delete"
                                        @click="removeCart(item.shoppingCartId,item.course.courseTitle)" />
                            </li>
                            <li>
                                <div>
                                    <div v-if="$func.isTrue(item.course.isDiscount)">
                                        <span style="color:#999;text-decoration: line-through;">￥{{item.course.coursePrice}}</span>
                                        <span>￥{{item.course.discountPrice}}</span>
                                    </div>
                                    <div v-else>
                                        ￥{{item.course.coursePrice}}
                                    </div>
                                </div>
                                <a-tag v-if="$func.isTrue(item.course.isDiscount)" color="#f50" style="margin:0">
                                    {{item.course.discountDesc}}
                                </a-tag>
                            </li>
                        </ul>
                    </div>
                </template>
            </div>
        </a-spin>
    </div>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    import {DISPATCH_REMOVE_CART} from "@constants/action-type/cart-action-type";
    import {COMMIT_ADD_CART_SELECTED, COMMIT_REMOVE_CART_SELECTED} from "@constants/mutation-type/cart-mutation-type";
    import common from "../../../mixin/common";

    const {mapState, mapGetters} = createNamespacedHelpers('cart');

    export default {
        name: "CartList",
        mixins: [common],
        data() {
            return {
                mobileStyle: {
                    'padding-bottom': '50px'
                }
            }
        },
        methods: {
            getSelected(id) {
                return this.selectList.some(item => {
                    return item.shoppingCartId === id;
                })
            },
            removeCart(id, name) {
                this.$store.dispatch({
                    type: DISPATCH_REMOVE_CART,
                    shoppingCartId: id,
                    courseName: name
                })
            },
            onSelected(e, cartInfo) {
                if (e.target.checked) {
                    this.$store.commit({
                        type: COMMIT_ADD_CART_SELECTED,
                        cartInfo
                    })
                } else {
                    this.$store.commit({
                        type: COMMIT_REMOVE_CART_SELECTED,
                        shoppingCartId: cartInfo.shoppingCartId
                    })
                }
            },
        },
        computed: {
            ...mapState([
                "cartList",
                "selectList",
                "isLoading"
            ]),
            ...mapGetters([
                "checkAll",
                "indeterminate",
            ])
        }
    }
</script>

<style scoped lang="less">
    @import '../styles/shopping-cart.less';
    @import "../../../styles/variable";

    .list-loading {
        min-height: 120px;
        background-color: #999;
        margin-top: 20px;
    }

    .delete {
        color: red;
    }

    .cart-list {
        border: 1px solid #e8e8e8;
        margin: 20px 0;
        padding: 10px 0;

        .cart-table {
            li {
                line-height: 40px;
            }

            li:nth-of-type(1) {
                img {
                    width: 156px;
                    height: 100%;
                    margin-left: 10px;
                }
            }

            li:nth-of-type(3) {
                color: #FF4F23;
            }
        }
    }

    // 移动端样式
    .mobile-cart-list {
        margin: 0 0 15px 0;
        border: none;
        display: flex;

        .course-cover {
            width: 50%;
            display: flex;
            justify-content: space-around;
            align-items: center;

            img {
                display: block;
                width: calc(100% - 30px);
            }
        }

        .mobile-course-desc {
            display: flex;
            flex-direction: column;
            flex: 1;
            justify-content: space-between;
            padding-left: 10px;

            li {
                display: flex;
                justify-content: space-between;
            }

            .delete {
                padding-top: 3px;
            }
        }
    }

</style>
